export default "__VITE_ASSET__BTInlKjD__"